import { 
    RESET_CHOICES,
    ADD_CHOICE 
} from './constants/ActionTypes';

/*
 * Action creator to reset all choices
 *
 */
export const resetChoices = () => ({
    type: RESET_CHOICES
});

/*
 * Action creator to set a new choice (slotId: course)
 *
 */
export const addChoice = (slotId, course) => ({
    type: ADD_CHOICE,
    choice: { [slotId] : course }
})